import { ArticlePage, MetaData } from '@/components'

export default function NextArticlePage(props) {
  const { meta } = props
  const { title: titleFromProps, description: descFromProps } = meta;
  const title = titleFromProps || props.title;
  const description = descFromProps
  return (
    <>
      <MetaData title={title} description={description} />
      <ArticlePage {...props} />
    </>
  )
}

NextArticlePage.getInitialProps = async ({ query, api }) => {
  const { articleSlug, ...otherQueries } = query

  const response = await api.article({ slug: articleSlug, ...otherQueries })

  const { data } = response

  return { ...data, pageType: 'article'  }
}
